var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" Lorem ipsum, dolor sit amet consectetur adipisicing elit. Minima natus, voluptatem facere suscipit vitae recusandae ipsum libero dolorum soluta mollitia voluptates in non et. Eaque dolorem dicta quisquam dignissimos mollitia? ")])
}
var staticRenderFns = []

export { render, staticRenderFns }